<template>
  <div>
    <v-form>
      <v-container>
        <v-row>
          <v-alert v-model="hasError" dense outlined type="error" dismissible>
            Something went wrong with authenticating verifying your code. Please
            try again.
          </v-alert>
          <v-alert
            v-model="resentCode"
            dense
            outlined
            type="warning"
            dismissible
          >
            <small>
              We have sent a 6 digit verification code to your email. Please
              check your e-mail inbox for a new code.
            </small>
          </v-alert>
        </v-row>
        <v-row>
          <v-col cols="12"><h3>Verify Your Identity</h3></v-col>
          <v-col cols="12"
            >Please enter the 6-digit verification code sent to your
            email.</v-col
          >
        </v-row>
        <v-row align="center">
          <v-col cols="10" sm="10">
            <v-text-field
              v-model="twoFaInput"
              label="Verification Code"
              clearable
              type="number"
              :disabled="isLoading"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn
              @click="submitCode"
              outlined
              type="submit"
              :disabled="isLoading"
              color="primary darken-2"
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              @click="resendCode"
              small
              :disabled="isLoading"
              color="purple lighten-3"
            >
              Re-Send Code
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <div v-if="isLoading" class="text-center"><LoadingSpinner /></div>
  </div>
</template>

<script>
import { differenceInHours } from "date-fns";
import { sendTwoFactorCode, verifyTwoFactorUser } from "API/user";
import LoadingSpinner from "~/components/LoadingSpinner";

export default {
  name: "TwoFactorVerification",
  components: {
    LoadingSpinner,
  },
  data: () => ({
    twoFaInput: "",
    isLoading: false,
    hasError: false,
    resentCode: false,
  }),
  methods: {
    async resendCode() {
      this.isLoading = true;
      this.resentCode = false;
      this.hasError = false;
      try {
        const { __raw: jwt = "" } = await this.$auth.getIdTokenClaims();
        await sendTwoFactorCode(jwt);
        this.resentCode = true;
      } catch (err) {
        this.hasError(true);
      } finally {
        this.isLoading = false;
      }
    },
    async submitCode() {
      this.isLoading = true;
      this.hasError = false;
      try {
        const { __raw: jwt = "" } = await this.$auth.getIdTokenClaims();
        const { data } = await verifyTwoFactorUser(jwt, {
          code: this.twoFaInput,
        });
        if (data?.error) {
          this.isLoading = false;
          this.hasError = true;
        }
        if (!data?.error && data) {
          window.location.href = "/inventory";
        }
      } catch (err) {
        this.hasError = false;
      }
    },
  },
  async mounted() {
    this.isLoading = true;
    try {
      if (
        this?.$auth?.user?.twoFaVerified &&
        this.$auth?.user?.twoFaVerifiedTS &&
        differenceInHours(
          new Date(this.$auth?.user?.serverTime),
          new Date(this.$auth?.user?.twoFaVerifiedTS)
        ) < 24
      ) {
        this.$router.push({ path: "/inventory" });
      } else {
        const { __raw: jwt = "" } = await this.$auth.getIdTokenClaims();
        await sendTwoFactorCode(jwt);
      }
    } catch (err) {
      console.log({ err });
    } finally {
      this.isLoading = false;
    }
  },
};
</script>
